import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireGetCobaltTailwindcssConfig } from "/Users/thibaudesnouf/sources/cobalt/utils/getCobaltTailwindcssConfig.js";
var getCobaltTailwindcssConfigExports = requireGetCobaltTailwindcssConfig();
export { getCobaltTailwindcssConfigExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(getCobaltTailwindcssConfigExports);